import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { api } from "@/lib/api"

interface Merchant {
  id: string
  rawId: string | null
  cleanName: string | null
  isPerson: boolean | null
  isRecurring: boolean | null
  householdId?: string | null
  categoryId?: string | null
  notes?: string | null
}

interface ListResponse {
  success: boolean
  data: Merchant[]
}

interface SingleResponse {
  success: boolean
  data: Merchant
}

export interface MerchantInput {
  cleanName: string
  rawId?: string
  categoryId?: string | null
  isPerson?: boolean
  isRecurring?: boolean
  notes?: string | null
}

export function useMerchants() {
  return useQuery({
    queryKey: ["merchants"],
    queryFn: () => api.get<ListResponse>("/merchants"),
    staleTime: 5 * 60 * 1000,
  })
}

export function useCreateMerchant() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: MerchantInput) => api.post<SingleResponse>("/merchants", body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["merchants"] }),
  })
}
